import apiClient from '@/services/axios'

export async function put(venue) {

  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-details', venue);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get Team Members.')
}
